const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NUMBERS = "0123456789";
const SYMBOLS = "!@#$%^&*()-_=+[]{};:,.?";

function getRandomValues(length) {
  const bytes = new Uint32Array(length);
  window.crypto.getRandomValues(bytes);
  return bytes;
}

export function generatePassword({ length = 10, numbers = true, symbols = false, uppercase = true } = {}) {
  const charset = `${LOWER}${uppercase ? UPPER : ""}${numbers ? NUMBERS : ""}${symbols ? SYMBOLS : ""}`;
  if (!charset) return "";

  const randomValues = getRandomValues(length);
  let password = "";
  for (let i = 0; i < length; i += 1) {
    password += charset[randomValues[i] % charset.length];
  }
  return password;
}
